import Vimeo from 'vimeo';

const VIMEO = {
  client_id: 'd236a40259bf049973739187a9ed62f93e6ab8c1',
  client_secret:
    'modqDUCydMuYWx10eY/BRAylkofsl9RHsDTQynWM8dsMN9HfAWt2rZ5ZJd6MsSXBOIGer0v2yZsMDRXl0TIkP3/Wz04gscltuFkijYpSKV9G/bRmC9UEiDy0/zPlGFzQ',
  access_token: '8937ca1661c96f149f9ec930534c8311',
};

const UploadToVimeo = (file, folder, id, keyName) => {
  return new Promise((resolve, reject) => {
    var g_client = new Vimeo.Vimeo(VIMEO.client_id, VIMEO.client_secret, VIMEO.access_token);
    g_client.upload(
      file,
      { name: id, description: '' },
      (url) => {
        console.log(url);
        let buff = url.split('/');
        resolve({ name: file.name, path: `https://player.vimeo.com/video/${buff[2]}` });
      },
      (bytes_uploaded, bytes_total) => {
        var percentage = ((bytes_uploaded / bytes_total) * 100).toFixed(2);
        console.log(bytes_uploaded, bytes_total, percentage + '%');
      },
      (err) => {
        console.log(err);
      },
    );
  });
};

export default UploadToVimeo;
